import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue"
import MoneyInput, { MoneyInputValue } from "@/components/widgets/input/MoneyInput.vue"
import Header from "@/modules/Missions/components/Payment/SetupPaymentHeader.vue"
import { MissionContractPayment } from "@/gql"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'StaffingPositionFeeInput',
  props: {
    totalFees: null,
    isSubmitting: { type: Boolean },
    clientPayments: null
  },
  emits: ["close", "complete"],
  setup(__props: any, { emit }: { emit: ({
  (e: "close"): void
  (e: "complete", totalFees: MoneyInputValue): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  totalFees: MoneyInputValue
  isSubmitting?: boolean
  clientPayments?: MissionContractPayment[]
}





const form = ref<{
  totalFees: MoneyInputValue
}>({
  totalFees: {
    amount: null,
    currency: "USD",
  },
})

watch(
  props.totalFees,
  (newVal: MoneyInputValue) => {
    if (newVal.amount) {
      form.value.totalFees = newVal
    }
  },
  { immediate: true, deep: true }
)

return { __sfc: true,props, emit, form, MoneyInput, Header, Icon }
}

})